import React, { Component } from 'react';
import numeral from 'numeral';
import { connect } from 'react-redux';
import {List, Map} from "immutable";
import {Icon} from "@blueprintjs/core";
import _ from "lodash";
import {isFloat} from 'validator';

// Components
import Select from "../../../components/common/virtualized-select";
import CostBreakdownLinesTable from "../../../components/common/CostBreakdownLinesTable";

// Actions
import {getCustomers, cleanCustomers} from "../../../actions/customers";
import {getProducts, getProduct, cleanProducts} from "../../../actions/products";

// Numeral configuration
import 'numeral/locales/es-es';
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

class CostBreakdownDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canNewLine: false,
            // object fields
            breakdown_code: '',
            name: '',
            customer: -1,
            comments: '',
            products: List([]),
            costPrices: List([Map({ _id: -1, price: "Selecciona un precio" })]),
            selectedCostPrice: -1,
            lines: List([]),
            // lines
            product: -1,
            commentsLine: '',
            amount: 0,
            price: 0,
            discount: 0,
            cnc: 0,
            total: 0,
            // Statistics
            breakdownTotal: numeral(0).format()
        }
    }
    componentDidMount() {
        this.updateCostBreakdownState();
        this.props.onRef(this);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.costBreakdown !== prevProps.costBreakdown) {
            this.updateCostBreakdownState();
        }

        // Calculate Statistics
        if (this.state.lines !== prevState.lines) {
            let breakdownTotal = 0;

            this.state.lines.forEach(line => {
                breakdownTotal = breakdownTotal + line.get('total');
            });

            this.setState({
                breakdownTotal: numeral(breakdownTotal).format()
            });
        }

        // On Edit Mode
        if (this.props.editMode !== prevProps.editMode && this.props.editMode) {
            this.props.getCustomers({
                filters: {
                    status: 'active'
                },
                projection: 'customer_code basic_info.name',
                deleteVirtuals: true
            });
            this.props.getProducts({
                filters: {
                    status: 'active'
                },
                projection: 'product_code name',
                deleteVirtuals: true
            });
        }

        // Handle products and costPrices
        let products = this.props.products;
        if (products !== prevProps.products) {
            if (products instanceof List) {
                if (products.size > 0) {
                    products = products.map(product => {
                        return product.set('select', `[${product.get('product_code')}] ${product.get('name')}`);
                    });
                }
                products = products.insert(0, Map({ _id: -1, select: 'Selecciona un producto' }));
                this.setState({ products });
            }
            else {
                if (products.get('cost_prices')) {
                    this.setState({
                        costPrices: products.get('cost_prices').insert(0, Map({ _id: -1, price: "Selecciona un precio" }))
                    });
                }
            }
        }

    }
    componentWillUnmount() {
        this.props.cleanProducts();
        this.props.cleanCustomers();
        this.props.onRef(undefined);
    }

    updateCostBreakdown = () => {
        let lines = new List([]);

        this.state.lines.forEach(line => {
            lines = lines.insert(lines.size, line
                .set('product', line.getIn(['product', '_id']))
                .delete('_id')
                .delete('total')
            )
        });

        this.props.updateCostBreakdown(this.props.costBreakdown.get('_id'), {
            // object fields
            name: this.state.name,
            ...(this.state.customer !== -1) ? { customer: this.state.customer } : '',
            comments: this.state.comments,
            lines
        });
    };
    updateCostBreakdownState = () => {
        this.setState({
            // object fields
            breakdown_code: this.props.costBreakdown.get('breakdown_code') || '',
            name: this.props.costBreakdown.get('name') || '',
            customer: this.props.costBreakdown.getIn(['customer','_id']) || -1,
            comments: this.props.costBreakdown.get('comments') || '',
            products: List([]),
            costPrices: List([Map({ _id: -1, price: "Selecciona un precio" })]),
            selectedCostPrice: -1,
            lines: this.props.costBreakdown.get('lines'),
            // new line
            product: -1,
            supplier: -1,
            commentsLine: '',
            amount: 0,
            price: 0,
            discount: 0,
            cnc: 0,
            total: 0,
            // statistics
            breakdownTotal: numeral(this.props.costBreakdown.getIn(['statistics', 'total'])).format()
        })
    };
    deleteLine = index => {
        this.setState({
            lines: this.state.lines.delete(index)
        }, this.validateCostBreakdown);
    };
    validateLine = () => {
        if (
            this.state.product !== -1 &&
            this.state.amount !== 0
        ) {
            this.setState({ canNewLine: true });
        } else {
            this.setState({ canNewLine: false });
        }
    };
    validateCostBreakdown = () => {
        if (
            this.state.name !== ''
        ) {
            this.props.canSubmit(true);
        } else {
            this.props.canSubmit(false);
        }
    };

    render() {
        let costBreakdownDetail;

        if (!this.props.editMode) {
            costBreakdownDetail = (
                <div className="panel-body" >
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Código de escandallo *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={ this.props.costBreakdown.get('breakdown_code') }
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Nombre *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.props.costBreakdown.get('name')}
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <label>Cliente</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.props.costBreakdown.getIn(['customer', 'basic_info', 'name'])}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row" style={{ paddingBottom: 16 }} >
                        <div className="col-12">
                            <label>Comentarios</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.props.costBreakdown.get('comments')}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <h4>Lineas de escandallo</h4>
                    <CostBreakdownLinesTable
                        costBreakdownLines={this.props.costBreakdown.get('lines')}
                    />
                    <div className="row stats-zone d-flex justify-content-end">
                        <div className="col-auto">
                            <span className="label ">{ numeral(this.props.costBreakdown.getIn(['statistics', 'total'])).format() }</span>
                            <span>Total</span>
                        </div>
                    </div>
                </div>
            );
        } else {
            costBreakdownDetail = (
                <div className="panel-body" >
                    <div className="row">
                        <div className="col-3">
                            <div className="form-group">
                                <label>Código de escandallo *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={ this.props.costBreakdown.get('breakdown_code') }
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group">
                                <label>Nombre *</label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={this.state.name}
                                    onChange={ (event) => {
                                        this.setState({
                                            name: event.target.value
                                        }, this.validateCostBreakdown);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-3">
                            <label>Cliente</label>
                            <Select
                                className="virtualized-select"
                                options={this.props.customers.toJS()}
                                value={this.state.customer}
                                labelKey="select"
                                valueKey="_id"
                                matchProp="select"
                                multi={false}
                                searchable={true}
                                clearable={false}
                                onChange={(customer) => {
                                    if (customer && customer._id !== this.state.customer) {
                                        this.setState({
                                            customer: customer._id,
                                        }, this.validateCostBreakdown);
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="row" style={{ paddingBottom: 16 }} >
                        <div className="col-12">
                            <label>Comentarios</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.comments}
                                onChange={ (event) => {
                                    this.setState({
                                        comments: event.target.value
                                    }, this.validateCostBreakdown);
                                }}
                            />
                        </div>
                    </div>
                    <h4>Lineas de escandallo</h4>
                    <div className="row" style={{ paddingBottom: 16 }} >
                        <div className="col-3">
                            <label>Producto *</label>
                            <Select
                                className="virtualized-select"
                                options={this.state.products.toJS()}
                                value={this.state.product}
                                labelKey="select"
                                valueKey="_id"
                                matchProp="select"
                                multi={false}
                                searchable={true}
                                clearable={false}
                                onChange={(product) => {
                                    if (product && product._id !== this.state.product) {
                                        this.props.getProduct(product._id, {
                                            projection: '_id',
                                            populateRefs: true
                                        });
                                        this.setState({
                                            product: product._id,
                                            selectedCostPrice: -1
                                        }, this.validateLine);
                                    }
                                }}
                            />
                        </div>
                        <div className="col-3">
                            <label>Últimos costes del producto</label>
                            <Select
                                className="virtualized-select"
                                options={this.state.costPrices.toJS()}
                                value={this.state.selectedCostPrice}
                                labelKey="price"
                                valueKey="_id"
                                matchProp="price"
                                multi={false}
                                searchable={true}
                                clearable={false}
                                disabled={this.state.product === -1 || this.state.costPrices.size <= 1}
                                onChange={(selectedCostPrice) => {
                                    if (selectedCostPrice && selectedCostPrice._id !== this.state.selectedCostPrice) {
                                        if (selectedCostPrice._id !== -1) {
                                            let price = selectedCostPrice.price;
                                            let subtotalCost, discount, subtotal, total;

                                            if (price === '') price = '0';
                                            if (isFloat(price.toString())) {
                                                subtotalCost = _.round(this.state.amount, 5) * _.round(price, 5);
                                                discount = subtotalCost * (_.round(this.state.discount, 2) / 100);
                                                subtotal = subtotalCost - discount;
                                                total = subtotal + _.round(this.state.cnc, 5);

                                                this.setState({
                                                    selectedCostPrice: selectedCostPrice._id,
                                                    price,
                                                    total: _.round(total, 2)
                                                });
                                            }
                                        }
                                        else {
                                            this.setState({ selectedCostPrice: selectedCostPrice._id });
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="row" style={{ paddingBottom: 16 }} >
                        <div className="col-6">
                            <label>Comentarios</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.commentsLine}
                                onChange={ (event) => {

                                    this.setState({
                                        commentsLine: event.target.value
                                    });
                                }}
                                disabled={this.state.product === -1}
                            />
                        </div>
                        <div className="col">
                            <label>Cantidad</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.amount}
                                onChange={ (event) => {
                                    let amount = event.target.value;
                                    let subtotalCost, discount, subtotal, total;

                                    if (amount === '') amount = '0';
                                    if (isFloat(amount)) {
                                        subtotalCost = _.round(amount, 5) * _.round(this.state.price, 5);
                                        discount = subtotalCost * (this.state.discount / 100);
                                        subtotal = subtotalCost - discount;
                                        total = subtotal + _.round(this.state.cnc, 5);

                                        this.setState({
                                            amount,
                                            total: _.round(total, 2)
                                        }, this.validateLine);
                                    }
                                }}
                                disabled={this.state.product === -1}
                            />
                        </div>
                        <div className="col">
                            <label>Precio</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.price}
                                onChange={ (event) => {
                                    let price = event.target.value;
                                    let subtotalCost, discount, subtotal, total;

                                    if (price === '') price = '0';
                                    if (isFloat(price)) {
                                        subtotalCost = _.round(this.state.amount, 5) * _.round(price, 5);
                                        discount = subtotalCost * (_.round(this.state.discount, 2) / 100);
                                        subtotal = subtotalCost - discount;
                                        total = subtotal + _.round(this.state.cnc, 5);

                                        this.setState({
                                            price,
                                            total: _.round(total, 2)
                                        });
                                    }
                                }}
                                disabled={this.state.product === -1}
                            />
                        </div>
                        <div className="col">
                            <label>Descuento (%)</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.discount}
                                onChange={ (event) => {
                                    let discount = event.target.value;
                                    let subtotalCost, discountLine, subtotal, total;

                                    if (discount === '') discount = '0';
                                    if (isFloat(discount)) {
                                        subtotalCost = _.round(this.state.amount, 5) * _.round(this.state.price, 5);
                                        discountLine = subtotalCost * (_.round(discount, 2) / 100);
                                        subtotal = subtotalCost - discountLine;
                                        total = subtotal + _.round(this.state.cnc, 5);

                                        this.setState({
                                            discount,
                                            total: _.round(total, 2)
                                        });
                                    }
                                }}
                                disabled={this.state.product === -1}
                            />
                        </div>
                        <div className="col">
                            <label>CNC</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.cnc}
                                onChange={ (event) => {
                                    let cnc = event.target.value;
                                    let subtotalCost, discount, subtotal, total;

                                    if (cnc === '') cnc = '0';
                                    if (isFloat(cnc)) {
                                        subtotalCost = _.round(this.state.amount, 5) * _.round(this.state.price, 5);
                                        discount = subtotalCost * (_.round(this.state.discount, 2) / 100);
                                        subtotal = subtotalCost - discount;
                                        total = subtotal + _.round(cnc, 5);

                                        this.setState({
                                            cnc,
                                            total: _.round(total, 2)
                                        });
                                    }
                                }}
                                disabled={this.state.product === -1}
                            />
                        </div>
                        <div className="col">
                            <label>Total</label>
                            <input
                                className="form-control"
                                type="text"
                                value={this.state.total}
                                disabled={true}
                            />
                        </div>
                        <div className="col-auto" style={{ paddingTop: 23 }} >
                            <button
                                className="btn btn-custom"
                                disabled={!this.state.canNewLine}
                                onClick={() => {
                                    let lines = new List(this.state.lines);
                                    let index = this.state.products.findIndex( product => product.get('_id') === this.state.product );
                                    const product = this.state.products.get(index);

                                    lines = lines.insert(lines.size, Map({
                                        _id: lines.size,
                                        product,
                                        comments: this.state.commentsLine,
                                        amount: _.round(this.state.amount, 5),
                                        price: _.round(this.state.price, 5),
                                        discount: _.round(this.state.discount, 2),
                                        cnc: _.round(this.state.cnc, 5),
                                        total: _.round(this.state.total, 2)
                                    }));

                                    this.setState({
                                        lines,
                                        product: -1,
                                        commentsLine: '',
                                        amount: 0,
                                        price: 0,
                                        discount: 0,
                                        cnc: 0,
                                        total: 0,
                                        canNewLine: false
                                    }, this.validateCostBreakdown);
                                }}
                            >
                                <Icon
                                    style={{ margin: '2px 0px' }}
                                    icon="plus" title="Añadir"
                                />
                            </button>
                        </div>
                    </div>
                    <CostBreakdownLinesTable
                        editMode={true}
                        costBreakdownLines={this.state.lines}
                        deleteLine={this.deleteLine}
                    />
                    <div className="row stats-zone d-flex justify-content-end">
                        <div className="col-auto">
                            <span className="label ">{ this.state.breakdownTotal }</span>
                            <span>Total</span>
                        </div>
                    </div>
                </div>
            );
        }

        return costBreakdownDetail;
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const customersReducer = state.customers;
    const productsReducer = state.products;

    // Customers
    let customers = customersReducer.get('payload') || List([]);
    if (!(customers instanceof List)) customers = List([]);
    if (customers.size > 0) {
        customers = customers.map(customer => {
            return customer.set('select', `[${customer.get('customer_code')}] ${customer.getIn(['basic_info', 'name'])}`);
        });
    }
    customers = customers.insert(0, Map({ _id: -1, select: 'Selecciona un cliente' }));

    // Products
    const products = productsReducer.get('payload') || List([]);

    return {
        customers,
        products
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCustomers: (query) => dispatch(getCustomers(query)),
        getProducts: (query) => dispatch(getProducts(query)),
        getProduct: (productId, options) => dispatch(getProduct(productId, options)),
        cleanCustomers: () => dispatch(cleanCustomers()),
        cleanProducts: () => dispatch(cleanProducts())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CostBreakdownDetail);



// WEBPACK FOOTER //
// ./src/containers/sales/cost-breakdowns/CostBreakdownDetail.js